import { render, staticRenderFns } from "./ChartOfAccount.vue?vue&type=template&id=1f5d3694&scoped=true"
import script from "./ChartOfAccount.vue?vue&type=script&lang=js"
export * from "./ChartOfAccount.vue?vue&type=script&lang=js"
import style0 from "./ChartOfAccount.vue?vue&type=style&index=0&id=1f5d3694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d3694",
  null
  
)

export default component.exports